<dx-popup
  [visible]="displayAddDialog()"
  (visibleChange)="displayAddDialog.set($event)"
  [width]="'40%'"
  [height]="'auto'"
  [maxHeight]="'85vh'"
  [resizeEnabled]="true"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="dialog-header">
    <div class="dialog-title">
      <i class="fas fa-map-pin"></i>
      <strong>Ajouter des points de livraison</strong>
    </div>
    <div class="dialog-actions">
      <yo-button
        iconClass="fas fa-check"
        tooltip="Ajouter les points de livraison sélectionnés"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="attachSelectedPlc()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>
  </div>

  @if (plcToAddList().length > 0) {
    <span class="genlabel font-10">{{ plcToAddList().length }} points de livraison disponibles</span>
    <dx-list
      [dataSource]="plcToAddList()"
      keyExpr="id"
      selectionMode="all"
      [showSelectionControls]="true"
      [(selectedItems)]="selectedPlcToAddList"
      [searchEnabled]="true"
      searchExpr="libelle"
      [height]="'55vh'">
      <div *dxTemplate="let item of 'item'">
        <i class="fas fa-map-pin mg-r-5"></i> {{ item.libelle }}
        <span class="genlabel font-12">({{ item.adresse?.ville }})</span>
      </div>
    </dx-list>
  } @else {
    <span class="genlabel font-12">
      <i class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun point de livraison disponible
    </span>
  }

</dx-popup>
